import dayjs from 'dayjs';
import isEmpty from 'lodash/isEmpty';

/**
 *
 * @param startsAt dayjs object, optional
 * @param dueAt dayjs object, optional
 * @param setErrorMessage function, (field, message) => void
 * @param clearErrorMessage function, (field) => void
 * @returns {boolean}
 */
const validateStartAndDueDate = (
  startsAt,
  dueAt,
  setErrorMessage = () => {},
  clearErrorMessage = () => {},
  startsAtField = 'startsAt',
  dueAtField = 'dueAt',
) => {
  if (isEmpty(startsAt) && isEmpty(dueAt)) {
    return true;
  }

  const isDueBeforeStarts =
    startsAt && dueAt && dayjs(dueAt).isBefore(dayjs(startsAt));

  if (isDueBeforeStarts) {
    const errorMessage =
      'You cannot set the due time earlier than the start time.';
    setErrorMessage(dueAtField, errorMessage);
    return false;
  }

  const isDueWithoutStarts = isEmpty(startsAt) && !isEmpty(dueAt);
  if (isDueWithoutStarts) {
    const errorMessage = 'Start must be set if due date is set';
    setErrorMessage(startsAtField, errorMessage);
    return false;
  }

  clearErrorMessage(startsAtField);
  clearErrorMessage(dueAtField);
  return true;
};

export { validateStartAndDueDate };
